import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

export default function FooterTW({ setCurrentPage }) {
  const nav = useNavigate();
  const loc = useLocation();

  const goHomeAnd = (pageKey) => {
    if (loc.pathname !== "/") nav("/");
    setCurrentPage?.(pageKey);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

const FooterLinkBtn = ({ children, onClick }) => (
  <button
    type="button"
    onClick={onClick}
    className="
      tw-bg-transparent tw-border-0 tw-appearance-none
      tw-p-0 tw-m-0 tw-font-inherit tw-leading-none
      tw-text-left tw-cursor-pointer
      tw-text-slate-300 hover:tw-text-white
    "
  >
    {children}
  </button>
);


  const Social = ({ href, label, children }) => (
    <a
      href={href}
      aria-label={label}
      className="tw-inline-flex tw-h-10 tw-w-10 tw-items-center tw-justify-center tw-rounded-full tw-bg-white/10 hover:tw-bg-white/15"
      target={href.startsWith("http") ? "_blank" : undefined}
      rel={href.startsWith("http") ? "noreferrer" : undefined}
    >
      {children}
    </a>
  );

  return (
  <footer className="tw-mt-16 tw-bg-[#0B2A3A] tw-text-slate-200">
    <div className="tw-mx-auto tw-max-w-6xl tw-px-4 tw-py-12">
      <div className="tw-grid tw-grid-cols-1 tw-gap-10 md:tw-grid-cols-3">
        {/* Brand + leírás + social */}
        <div>
          <div className="tw-flex tw-items-center tw-gap-3">
            <div className="tw-flex tw-items-center tw-gap-3">
			  <img
				src={process.env.PUBLIC_URL + "/logo512.png"}
				alt="Lelkigyakorlat-kereső"
				className="tw-h-10 tw-w-10 tw-rounded-xl tw-object-contain"
			  />
			  <div className="tw-font-semibold">Lelkigyakorlat-kereső</div>
			</div>

          </div>

          <p className="tw-mt-4 tw-max-w-sm tw-text-sm tw-text-slate-300 tw-leading-relaxed">
            Segítünk megtalálni a lelki feltöltődés helyét és idejét.
            Országos adatbázisunkban számos katolikus lelkigyakorlat közül válogathatsz.
          </p>

          {/* social wrapper */}
          <div className="tw-mt-6 tw-flex tw-items-center tw-gap-3">
            <Social href="mailto:lgykereso@gmail.com" label="Email">
              <svg viewBox="0 0 24 24" className="tw-h-5 tw-w-5" fill="currentColor" aria-hidden="true">
                <path d="M20 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm0 4-8 5L4 8V6l8 5 8-5v2z"/>
              </svg>
            </Social>
          </div>
        </div>

        {/* Felfedezés */}
        <div>
          <div className="tw-font-semibold tw-text-white">Felfedezés</div>
          <ul className="tw-mt-4 tw-space-y-3 tw-text-sm tw-list-none tw-p-0 tw-m-0">
            <li><FooterLinkBtn onClick={() => goHomeAnd("home")}>Keresés</FooterLinkBtn></li>
            <li>
              <Link className="tw-text-slate-300 hover:tw-text-white tw-no-underline" to="/terkep">
                Térképes nézet
              </Link>
            </li>
            <li><FooterLinkBtn onClick={() => goHomeAnd("home")}>Naptár</FooterLinkBtn></li>
          </ul>
        </div>

        {/* Információk */}
        <div>
          <div className="tw-font-semibold tw-text-white">Információk</div>
          <ul className="tw-mt-4 tw-space-y-3 tw-text-sm tw-list-none tw-p-0 tw-m-0">
            <li><FooterLinkBtn onClick={() => goHomeAnd("about")}>Rólunk</FooterLinkBtn></li>
            <li><FooterLinkBtn onClick={() => goHomeAnd("contact")}>Kapcsolat</FooterLinkBtn></li>
          </ul>
        </div>
      </div>

      <div className="tw-mt-10 tw-border-t tw-border-white/10" />

      <div className="tw-mt-6 tw-flex tw-flex-col tw-gap-3 tw-text-xs tw-text-slate-300 md:tw-flex-row md:tw-items-center md:tw-justify-between">
        <div>© 2026 Katolikus Lelkigyakorlat-kereső. Minden jog fenntartva.</div>
        <div className="tw-flex tw-items-center tw-gap-6" />
      </div>
    </div>
  </footer>
);

}
